import(/* webpackMode: "eager" */ "/vercel/path0/src/app/booking/page.js")